import React, { Component } from 'react';
import { getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import BuyXGetY from './BuyXGetY';

class Reward extends Component {
  render() {
    const { promoTypeForm, onSubmit, selectedOutlets } = this.props;
    if (!promoTypeForm) return <div />;
    switch (promoTypeForm.promoType.toLowerCase()) {
      case 'buy x get y':
        return (
          <BuyXGetY onSubmit={onSubmit} selectedOutlets={selectedOutlets} />
        );
      default:
        return <div />;
    }
  }
}

function mapStateToProps(state) {
  return {
    promoTypeForm: getFormValues('promoTypeAndName')(state),
  };
}

export default connect(mapStateToProps)(Reward);
